import { MacroState } from '../types';

/**
 * Removes redundant top-level fields that are now grouped under 
 * 'regimes' or 'riskMetrics' to ensure data consistency.
 */
export function sanitizeMacroState(data: any): MacroState {
  if (!data || typeof data !== 'object') return data;

  const result = { ...data };

  // 1. Remove top-level regime duplicates (favoring result.regimes)
  const regimeFields = ['creditRegime', 'liquidityRegime', 'policyRegime'];
  regimeFields.forEach(f => delete result[f]);

  // 2. Remove top-level risk metrics (favoring result.riskMetrics)
  const riskFields = ['macroWeight', 'portfolioRiskBudgetPct', 'riskScore', 'trimThresholdPct'];
  riskFields.forEach(f => delete result[f]);

  // 3. Remove top-level updatedAt (favoring result.riskMetrics.updatedAt)
  if (result.riskMetrics?.updatedAt && result.updatedAt) {
    delete result.updatedAt;
  }

  // 4. Standardize nested government indicators
  if (result.government) {
    const gov = { ...result.government };
    // Promote m2MoneySupply to m2 if it exists
    if (gov.m2MoneySupply && !gov.m2) {
      gov.m2 = gov.m2MoneySupply;
    }
    delete gov.m2MoneySupply;
    result.government = gov;
  }

  // 5. Remove 'indicators' group if redundant (often old signals)
  if (result.indicators && typeof result.indicators === 'object') {
    // Optionally keep it if specific indicators like 'vix' are only there
    // But currently we prefer structured top-level like fedFunds, treasury10Y etc.
    // delete result.indicators; 
  }

  return result as MacroState;
}

/**
 * Merges new indicator data into existing macro state while ensuring sanitization
 */
export function updateMacroState(current: MacroState, updates: Partial<MacroState>): MacroState {
  return sanitizeMacroState({
    ...current,
    ...updates
  });
}
